import React, { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from "react-i18next";

// styles
import './style.scss';

// antd component
import { Form, Button } from 'antd';

// assets
import { ArrowRightOutlined } from '@ant-design/icons';
import CustomIcons from 'components/CustomIcons';

// containers
import UploadMedia from 'mobile/containers/UploadMedia';
import UploadCameraMedia from 'mobile/containers/UploadCameraMedia';

// utils
import _local from 'utils/localStorageUtils';


function MediaForm({
  formData,
  isEdit,
  prevUnjustified,
  currentStep,
  // actions
  nextStep,
  prevStep,
  goToStep,
  result,
  // default
  className,
}) {
  const childClassName = classNames('form-absence', className);
  const { t } = useTranslation();

  const localUser = _local.getLocalUser();

  const [isDisabled, setIsDisabled] = useState(false);
  const [AbsFormMedia] = Form.useForm();

  const [mediaFiles, setMediaFiles] = useState([]);
  const [uploading, setUploading] = useState(false);


  /* 
   * Check current form data from parent
   * Set old data to the form
   */
  useEffect(() => {
    if (formData?.media?.length > 0) {
      AbsFormMedia.resetFields();
      // go to preview file
      !!goToStep && goToStep(currentStep+1);  

      setIsDisabled(false);
    }
  }, [formData]);

  // check media files if have it submit form
  useEffect(() => { 
    if (mediaFiles?.length > 0 && !!uploading) {
      AbsFormMedia.setFieldsValue({
        media: [...mediaFiles],
      });
      AbsFormMedia.submit();
    }
  }, [mediaFiles, uploading]);
  

  const onFinish = values => {
    result(values);
    setMediaFiles([]);
    AbsFormMedia.resetFields();
    !!nextStep && nextStep();
  };


  const noProofHandle = () => {
    const formValues = AbsFormMedia.getFieldsValue();
    const { media, ...restForm } = formValues;
    result({ ...restForm, media: [] });
    setMediaFiles([]);
    AbsFormMedia.resetFields();
    gotToResumeStep();
  }

  const gotToResumeStep = () => {
    if (!!goToStep) {
      const resumeStep = !!isEdit?._id && !prevUnjustified && localUser?.role == 'parent' ? 4 : 6;
      goToStep(resumeStep);
    }
  }

  const uploadMediaFiles = (data) => setMediaFiles(data); 

  return (
    <div className={childClassName}>
      <Form
        form={AbsFormMedia}
        className="form-absence__form form-proof__form"
        name="form_absence_media"
        initialValues={{}}
        onFinish={onFinish}
        onValuesChange={() => setIsDisabled(false)}
      >
        <div className="form-proof">

          <UploadCameraMedia
            name="media"
            media={mediaFiles}
            setProgress={setUploading}
            uploadChange={uploadMediaFiles} />
          
          <UploadMedia
            name="media"
            media={mediaFiles}
            setProgress={setUploading}
            uploadChange={uploadMediaFiles} />

          <Button
            className="proof-option"
            //form="form_absence_media"
            //htmlType="submit"
            onClick={noProofHandle}
            disabled={isDisabled}
          >
            <CustomIcons className="proof-option__icon" type="no-proof" />
            <span className="proof-option__description">
              {t("absences.emptyProof")}
            </span>
            <ArrowRightOutlined className="proof-option__arrow" />
          </Button>
        </div>

        {!(isEdit?._id && !prevUnjustified && localUser?.role == 'parent') && (
          <div className="absence-actions-wrapper">
            <Button
              className="btn-previous"
              onClick={prevStep}
            >
              {t("common.previous")}
            </Button>
          </div>
        )}
      </Form>
    </div>
  );
}

MediaForm.defaultProps = {};
MediaForm.propTypes = {
  result: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
  prevStep: PropTypes.func.isRequired,
  goToStep: PropTypes.func.isRequired,
};

export default memo(MediaForm);
